import { Injectable, Inject } from '@angular/core';
import { BaseService } from '../base.service';

declare var OpenPay;

@Injectable()
export class OpenPayService extends BaseService {

  private _deviceSessionId: string;

  get deviceSessionId(): string {
    return this._deviceSessionId;
  }

  constructor() {
    super();

    OpenPay.setId('mpripizokjynemqrd7sa');
    OpenPay.setApiKey('pk_8401a106f8e2476983e3a67f99ae8812');
    OpenPay.setSandboxMode(true);

    this._deviceSessionId = OpenPay.deviceData.setup();
  }

  createCardToken(cardInfo: any): Promise<any> {
    let cardInfoCopy = Object.assign({  }, cardInfo);

    return new Promise<any>((resolve, reject) => {
      OpenPay.token.create(cardInfo,
        response => resolve(response),
        error => this.handleErrorAsPromise(error)
      );
    });
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/openpay/openpay.service.ts